import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { getPhotoURL } from "../utils/images";
import { SFEntityID } from "../utils/types";

export class AttendanceRosterStudentRow extends React.Component {

  render() {
    return (
      <Table.Row>
        <Table.Cell><img src={getPhotoURL(this.props.uuid, this.props.hasPhoto)} width="50" height="50" /></Table.Cell>
        <Table.Cell>{this.props.name}</Table.Cell>
        <Table.Cell>{this.props.phone}</Table.Cell>
        <Table.Cell>{this.props.email}</Table.Cell>
      </Table.Row>
    );
  }

}

AttendanceRosterStudentRow.propTypes = {
  id: SFEntityID.isRequired,
  uuid: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  phone: PropTypes.string,
  email: PropTypes.string,
  hasPhoto: PropTypes.bool
};
